import {gql} from '@apollo/client';

export const CREATE_AI_SKILL = gql`
  mutation CreateSkill($input: CreateSkillInput!) {
    createSkill(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithSkill {
        message
      }
    }
  }
`;

export const GET_ALL_AI_SKILLS = gql`
  query GetSkills($filter: SkillFilterInput) {
    getSkills(filter: $filter) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithSkills {
        data {
          id
          domain
          node
          tree
          status
          createdBy {
            firstName
            lastName
            email
            id
          }
          updatedBy {
            firstName
            lastName
            email
            id
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const UPDATE_AI_SKILL = gql`
  mutation UpdateSkill($input: UpdateSkillInput!) {
    updateSkill(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithSkill {
        message
      }
    }
  }
`;

export const GET_SKILL_MARKDOWN_TRANSLATIONS = gql`
  query Data($filter: SkillTranslationFilterInput) {
    getSkillTranslations(filter: $filter) {
      ... on ResponseWithSkillTranslations {
        data {
          id
          skillId
          language
          title
          description
          contentMarkdown
          createdBy {
            firstName
            lastName
            email
            id
          }
          updatedBy {
            firstName
            lastName
            email
            id
          }
          createdAt
          updatedAt
        }
      }
      ... on Error {
        statusCode
        message
      }
    }
  }
`;

export const CREATE_SKILL_TRANSLATION = gql`
  mutation CreateSkillTranslations($input: CreateSkillTranslationsInput!) {
    createSkillTranslations(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithSkillTranslations {
        message
      }
    }
  }
`;

export const UPDATE_SKILL_TRANSLATION = gql`
  mutation UpdateSkillTranslation($input: UpdateSkillTranslationInput!) {
    updateSkillTranslation(input: $input) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithSkillTranslation {
        message
      }
    }
  }
`;
